module.exports = __webpack_public_path__ + "img/help_register_y@3x.4a251fc6.png";